// extracted by mini-css-extract-plugin
module.exports = {"hero":"blog-post-module--hero--2480Z","layoutMarquee":"blog-post-module--layout--marquee--tp9oI"};